import React from "react";
import { Chip } from "@mui/material";

const CHIP_COLORS = {
  green: {
    color: "#118D57",
    bgColor: "#dbeee1",
  },
  orange: {
    color: "#E65100",
    bgColor: "#FFDAB9",
  },
  blue: {
    color: "#006C9C",
    bgColor: "#d8ecf2",
  },
  red: {
    color: "#f50505",
    bgColor: "#facdcd",
  },
  purple: {
    color: "#9605f7",
    bgColor: "#e6c8fa",
  },
  pink: {
    color: "#fa0791",
    bgColor: "#fac5e3",
  },
};

const CustomChip = ({ label, colorKey, size = "small", ...props }) => {
  const chipStyle = CHIP_COLORS[colorKey] || {};

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        backgroundColor: chipStyle.bgColor || "default",
        color: chipStyle.color || "default",
        borderRadius: "4px",
        padding: "1px",
        fontWeight: 500,
        border: `1px solid ${chipStyle.color}80`,
      }}
      {...props}
    />
  );
};

export default CustomChip;
